export default __webpack_public_path__ + "atomic/_patterns/02-molecules/content-section-text/_content-section-text.twig";